import { z } from 'zod';

export const getPatientsSchema = z.object({
  page: z
    .string()
    .optional()
    .default('0')
    .transform((val) => Number.parseInt(val, 10))
    .pipe(z.number().min(0)),
  limit: z
    .string()
    .optional()
    .default('10')
    .transform((val) => Number.parseInt(val, 10))
    .pipe(z.number().min(1).max(100)),
  sortBy: z.enum(['created_at', 'last_name', 'updated_at']).default('created_at'),
  sortDirection: z.enum(['asc', 'desc']).default('desc'),
  search: z.string().optional(),
});

export type GetPatientsPayload = z.infer<typeof getPatientsSchema>;
